import(/* webpackMode: "eager", webpackExports: ["Menu"] */ "/app/node_modules/@olinfo/react-components/dist/index.js");
